import apiRequestService from '@/commonProject/service/apiRequestService';

export default class UserSelectRepository {
    /**
     * ユーザー選択API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @param {*} idToken
     * @returns result
     */
    async getUserSelectApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/usrsel', requestBody, idToken);
        return result;
    }
}
